module.exports = __webpack_public_path__ + "static/media/github-api.0555bfb7.svg";